/*
 * <product-modal> — fullscreen image lightbox.
 * The theme ships the markup + the base <modal-dialog>/<modal-opener>
 * elements (in global.js) but never defines <product-modal>, so clicking a
 * product image did nothing. This registers it (extending modal-dialog) so
 * the existing modal-opener wiring opens the lightbox and scrolls to the
 * clicked image.
 */
customElements.whenDefined('modal-dialog').then(function () {
  if (customElements.get('product-modal')) return;
  var ModalDialogClass = customElements.get('modal-dialog');

  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialogClass {
      hide() {
        super.hide();
      }

      show(opener) {
        this.openedBy = opener;
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        var openedBy = this.openedBy;
        var activeId = openedBy && openedBy.getAttribute && openedBy.getAttribute('data-media-id');
        var items = this.querySelectorAll('[data-media-id]');
        var active = null;

        items.forEach(function (el) {
          var match = el.getAttribute('data-media-id') === activeId;
          el.classList.toggle('active', match);
          if (match) active = el;
        });
        if (!active) active = items[0];
        if (!active) return;

        // Instantiate a <template> (deferred media) if the image isn't there yet.
        var tmpl = active.querySelector('template');
        if (tmpl && !active.querySelector('img, model-viewer, iframe, video')) {
          active.appendChild(tmpl.content.firstElementChild.cloneNode(true));
        }
        active.scrollIntoView();
      }
    }
  );
});
